<template>
    <div class="primary--text">
        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t('agarre') | capitalize }}
                <v-tooltip bottom class="pl-2" max-width="500">
                    <template v-slot:activator="{on}">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>Material que constituirá la unión entre el material de revestimiento seleccionado y la superficie de colocación.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="escenario.tipoSoporte == null">
                    {{ $t('soporte_antes') | capitalize }}
                </div>
                <seleccion-componente-s-c v-if="escenario.tipoSoporte != null" :items="agarres" nombre="nombre"
                                          propiedad="codigo" v-model="solucionConstructiva.materialAgarre"
                                          :cargando="cargandoAgarres"
                                          @change="cargarRegularizaciones()">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t('regularizacion') | capitalize }}
                <v-tooltip bottom class="pl-2" max-width="500">
                    <template v-slot:activator="{on}">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>Su función es proporcionar planicidad dentro de unas tolerancias compatibles con la técnica de colocación.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2"
                     v-if="escenario.tipoSoporte == null || (agarreSeleccionada == null && !agarrePuedeSerNulo())"
                >
                    <span v-if="escenario.tipoSoporte == null && agarreSeleccionada == null">
                        {{ $t('soporte_agarr_antes') | capitalize }}
                    </span>
                    <span v-if="escenario.tipoSoporte == null && agarreSeleccionada != null">
                        {{ $t('soporte_antes') | capitalize }}
                    </span>
                    <span v-if="escenario.tipoSoporte != null && agarreSeleccionada == null">
                        {{ $t('agarr_antes') | capitalize }}
                    </span>
                </div>
                <seleccion-componente-s-c
                    v-if="escenario.tipoSoporte != null && (agarreSeleccionada != null || agarrePuedeSerNulo())"
                    :items="regularizaciones" nombre="nombre" propiedad="codigo"
                    :cargando="cargandoRegularizaciones"
                    v-model="solucionConstructiva.materialRegularizacion">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

    export default {
        name: "ComponentesVertical",
        components: {
            SeleccionComponenteSC
        },
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false},
        },
        data: function () {
            return {
                cargandoAgarres: false,
                agarres: [],
                cargandoRegularizaciones: null,
                regularizaciones: [],
            }
        },
        computed: {
            agarreSeleccionada() {
                return this.solucionConstructiva.materialAgarre;
            }
        },
        mounted() {
            Promise.all([
                this.cargarAgarres(),
                this.cargarRegularizaciones(),
            ]).then(() => {
                this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
            });
        },
        watch: {
            escenario: {
                handler() {
                    this.solucionConstructiva.materialAgarre = null;
                    this.cargarAgarres()
                        .then(() => {
                            this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                        });
                },
                deep: true
            },
            solucionConstructiva: {
                handler() {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarAgarres() {
                return new Promise((resolve) => {
                    if (this.escenario.tipoSoporte == null) {
                        resolve();
                        return;
                    }

                    this.cargandoAgarres = true;
                    let params = {
                        forzarTipoSoporte: this.escenario.tipoSoporte.codigo
                    };
                    let url = `obra-nueva/vertical/solucion-constructiva/${this.solucionConstructiva.id}/agarre`;
                    HttpHelper.get(url, params)
                        .then(data => {
                            this.agarres = data;
                            resolve()
                        })
                        .finally(() => {
                            this.cargandoAgarres = false;
                        });
                });
            },
            cargarRegularizaciones() {
                if (this.escenario.tipoSoporte == null) return;
                if (this.solucionConstructiva.materialAgarre == null) return;

                let params = {
                    forzarTipoSoporte: this.escenario.tipoSoporte.codigo,
                    forzarAgarre: this.solucionConstructiva.materialAgarre.codigo
                };
                this.cargandoRegularizaciones = true;
                let url = `obra-nueva/vertical/solucion-constructiva/${this.solucionConstructiva.id}/regularizacion`;

                let promise = HttpHelper.get(url, params);
                promise.then(data => {
                    this.regularizaciones = data;
                    if (this.solucionConstructiva.materialRegularizacion == null) return;

                    let encontrada = false;
                    data.forEach((regularizacion) => {
                        if (regularizacion != null &&
                            regularizacion.codigo == this.solucionConstructiva.materialRegularizacion.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialRegularizacion = null;
                    }
                }).finally(() => {
                    this.cargandoRegularizaciones = false;
                });

                return promise;
            },
            agarrePuedeSerNulo() {
                if (this.agarres.length == 0) return false;
                let hayNull = false;
                this.agarres.forEach((agarre) => {
                    if (agarre == null) hayNull = true;
                });
                return hayNull;
            },
            regularizacionPuedeSerNulo() {
                if (this.regularizaciones.length == 0) return false;
                let hayNull = false;
                this.regularizaciones.forEach((regularizacion) => {
                    if (regularizacion == null) hayNull = true;
                });
                return hayNull;
            },
            solucionConstructivaEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.materialAgarre == null && !this.agarrePuedeSerNulo()) {
                    return false;
                }
                if (solucionConstructiva.materialRegularizacion == null && !this.regularizacionPuedeSerNulo()) {
                    return false;
                }

                return true;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "agarre": "Agarre",
    "regularizacion": "Regularización",
    "soporte_antes": "Se debe seleccionar el tipo de soporte del escenario antes",
    "soporte_agarr_antes": "Se debe seleccionar el tipo de soporte del escenario y el agarre antes",
    "agarr_antes": "Se debe seleccionar el material de agarre antes"
    }
    }
</i18n>
<!--@formatter:on-->